// extracted by mini-css-extract-plugin
module.exports = {"next":"Next_next__5tJXc","next__txt":"Next_next__txt___bezR"};